export const calculateVolume = (items = []) => {
  return items.reduce(
    (acc, cur) => acc + Number(cur.cubic) * Number(cur.quantity),
    0
  );
};
